// extracted by mini-css-extract-plugin
export default {"paymentFormWrapper":"hLVhsN2kjvWR98KCbxsI"};